<template>
  <v-container fluid class="payment-gateways-container">
    <v-tabs slider-color="#587e27" class="futuristic-tabs">
      <v-tab key="gateways" class="earth-color" ripple>Payment Gateways</v-tab>
      <v-tab key="checkout" class="earth-color" ripple>Online Checkout</v-tab>
      <v-tab-item key="gateways">
        <v-layout row wrap>
          <v-flex lg5 md5 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <div class="card-header">
                  <h1 class="text-md-center earth-color">ADD NEW PAYMENT GATEWAY</h1>
                  <div class="title-decoration"></div>
                </div>
                <v-container>
                  <v-form @submit.prevent="postPaymentGateway()">
                    <v-text-field
                      label="Name"
                      v-model="payment_gateway.name"
                      :rules="requiredRules"
                      required
                      class="futuristic-input"
                    ></v-text-field>
                    <v-text-field
                      label="Account Code"
                      v-model="payment_gateway.code"
                      :rules="requiredRules"
                      required
                      class="futuristic-input"
                    ></v-text-field>
                    <v-autocomplete
                      label="Mode of Payment"
                      :items="allBookingPaymentMethods"
                      :rules="[v => !!v || 'Mode of payment is required']"
                      required
                      :return-object="true"
                      item-text="payment_method_name"
                      item-value="payment_method_public_id"
                      v-model="payment_gateway.method"
                      :loading="$loadingTrue"
                      @change="selectedPaymentMethod"
                      class="futuristic-input"
                    ></v-autocomplete>
                    <v-autocomplete
                      label="Currency to Be Paid In"
                      :items="$allCurrencies"
                      :rules="[v => !!v || 'Currency is required']"
                      required
                      v-model="payment_gateway.currency"
                      :return-object="true"
                      item-text="currency_name"
                      item-value="currency_public_id"
                      :loading="$loadingTrue"
                      @change="selectedPaymentCurrency"
                      class="futuristic-input"
                    ></v-autocomplete>
                    <v-btn
                      block
                      depressed
                      color="#587e27"
                      class="futuristic-btn"
                      type="submit"
                      v-if="edit === false"
                    >
                      Add Gateway
                    </v-btn>
                    <v-btn
                      block
                      depressed
                      color="#fbc531"
                      class="futuristic-btn"
                      type="submit"
                      v-if="edit === true"
                    >
                      Update Gateway
                    </v-btn>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
          <v-flex lg7 md7 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <div class="card-header">
                  <h1 class="text-md-center earth-color">ACTIVE PAYMENT GATEWAYS</h1>
                  <div class="title-decoration"></div>
                </div>
                <v-data-table
                  :headers="gatewayColumns"
                  :items="bookingPaymentGateways_"
                  :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
                  :disable-initial-sort="true"
                  :loading="$loadingTrue"
                  class="futuristic-table"
                >
                  <v-progress-linear
                    slot="progress"
                    color="#587e27"
                    indeterminate
                    height="3"
                  ></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <td>{{ props.index + 1 }}</td>
                    <td class="font-weight-medium">{{ props.item.payment_gateway_name }}</td>
                    <td>{{ props.item.payment_gateway_code }}</td>
                    <td>{{ props.item.payment_method_name }}</td>
                    <td>{{ props.item.payment_gateway_currency_name }}</td>
                    <td>
                      <v-btn
                        depressed
                        color="#fbc531"
                        small
                        class="futuristic-btn action-btn"
                        v-if="edit === false"
                        @click="editPaymentGateway(props.item)"
                      >
                        Edit
                      </v-btn>
                      <v-btn
                        depressed
                        color="#ef5350"
                        small
                        class="futuristic-btn action-btn"
                        v-if="edit === true"
                        @click="cancelEdit()"
                      >
                        Cancel Edit
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item key="checkout">
        <v-card flat class="futuristic-card">
          <div class="card-header">
            <h1 class="text-md-center earth-color">ONLINE PAYMENT OPTIONS</h1>
            <div class="title-decoration"></div>
          </div>
          <v-data-table
            :headers="optionColumns"
            :items="$paymentOptions"
            :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
            :disable-initial-sort="true"
            :loading="$loadingTrue"
            class="futuristic-table"
          >
            <v-progress-linear
              slot="progress"
              color="#587e27"
              indeterminate
              height="3"
            ></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td class="font-weight-medium">{{ props.item.payment_gateway_name.toUpperCase() }}</td>
              <td>
                <v-chip
                  :color="props.item.active ? '#44bd32' : '#ef5350'"
                  text-color="white"
                  class="status-chip"
                >
                  <v-avatar>
                    <v-icon>{{ props.item.active ? 'check_circle' : 'cancel' }}</v-icon>
                  </v-avatar>
                  {{ props.item.active ? 'Active' : 'Inactive' }}
                </v-chip>
              </td>
              <td>
                <v-btn
                  depressed
                  :color="props.item.active ? '#ef5350' : '#587e27'"
                  class="futuristic-btn action-btn"
                  @click="props.item.active ? deActivate(props.item.payment_gateway_public_id) : Activate(props.item.payment_gateway_public_id)"
                >
                  {{ props.item.active ? 'Deactivate' : 'Activate' }}
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
export default {
  name: 'PaymentGateways',
  data () {
    return {
      edit: false,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      search: '',
      payment_gateway: {
        payment_gateway_id: '',
        method: '',
        name: '',
        code: '',
        currency: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      },
      gatewayColumns: [
        {
          text: '#',
          value: 'index',
          class: 'table-header'
        },
        {
          text: 'Name',
          value: 'payment_gateway_name',
          class: 'table-header'
        },
        {
          text: 'Code',
          value: 'payment_gateway_code',
          class: 'table-header'
        },
        {
          text: 'Payment Method',
          value: 'payment_method_name',
          class: 'table-header'
        },
        {
          text: 'Currency',
          value: 'payment_gateway_currency_name',
          class: 'table-header'
        },
        {
          text: 'Action',
          value: '',
          class: 'table-header'
        }
      ],
      optionColumns: [
        {
          text: 'Name',
          value: 'payment_gateway_name',
          class: 'table-header'
        },
        {
          text: 'Status',
          value: 'active',
          class: 'table-header'
        },
        {
          text: 'Action',
          value: '',
          class: 'table-header'
        }
      ]
    }
  },
  beforeCreate () {
    this.$store.dispatch('get_all_credit_card_accounts')
    this.$store.dispatch('get_all_payment_methods')
    this.$store.dispatch('get_payment_platforms')
    this.$store.dispatch('fetch_mpesa_transactions')
  },
  created () {
    this.$store.dispatch('fetch_mpesa_transactions')
  },
  methods: {
    Activate (publicId) {
      let data = {
        gateway_id: publicId,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('activate_payment_option', data)
    },
    deActivate (publicId) {
      let data = {
        gateway_id: publicId,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('deactivate_payment_option', data)
    },
    cancelEdit () {
      this.edit = false
      this.payment_gateway.name = ''
      this.payment_gateway.code = ''
      this.payment_gateway.currency = ''
      this.payment_gateway.method = ''
      this.payment_gateway.payment_gateway_id = ''
    },
    selectedPaymentMethod () {
      this.payment_gateway.method = this.payment_gateway.method.payment_method_public_id
    },
    selectedPaymentCurrency () {
      this.payment_gateway.currency = this.payment_gateway.currency.currency_public_id
    },
    editPaymentGateway: function (paymentGateway) {
      this.edit = true
      this.payment_gateway.name = paymentGateway.payment_gateway_name
      this.payment_gateway.code = paymentGateway.payment_gateway_code
      this.payment_gateway.currency = paymentGateway.payment_gateway_currency
      this.payment_gateway.method = paymentGateway.payment_method
      this.payment_gateway.payment_gateway_id = paymentGateway.payment_gateway_public_id
    },
    deletePaymentGateway: function () {
      this.edit = false
      this.payment_gateway.name = ''
      this.payment_gateway.code = ''
      this.payment_gateway.currency = ''
    },
    postPaymentGateway: function () {
      var instance = this
      if (this.edit === false) {
        this.$store.dispatch('post_payment_gateway', this.payment_gateway).then(function () {
          this.$store.dispatch('get_all_payment_methods')
        })
      } else {
        this.$store.dispatch('update_payment_gateway', this.payment_gateway).then(function () {
          // instance.cancelEdit()
        })
      }
    },
    deletePromoType: function (publicId) {
      var data = {
        public_id: publicId,
        deleted_by: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('delete_promo_code_type', data)
    }
  }
}
</script>

<style scoped>
/* Futuristic Container */
.payment-gateways-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-gateways-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
  margin: 4px;
}

.status-chip {
  border-radius: 12px;
  font-weight: 500;
}

.futuristic-tabs >>> .v-tabs__bar {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  border-radius: 8px;
}

.futuristic-tabs >>> .v-tabs__item:hover {
  background-color: #f0f4f8;
  color: #587e27;
}

.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-gateways-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }

  .action-btn {
    margin: 2px;
  }
}

@media (max-width: 600px) {
  .payment-gateways-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }
}
</style>